import {createSlice} from "@reduxjs/toolkit";
import {TAudienceInitialState} from "@/types/redux/audienceTypes";
import {fetchAudiencesList, fetchFiltration} from "@/redux/audience/audienceActions";

const InitialState: TAudienceInitialState = {
    audiencesList: [],
    queryId: "",
    generalAudiencesSizeData: {
        existing_wallets: 0,
        identified_wallets: 0,
        avg_wallet_wealth: 0,
    },
};

const audienceSlice = createSlice({
    name: "audience",
    initialState: InitialState,
    reducers: {
        setAudienceField: (state, {payload}) => {
            return {...state, ...payload};
        },
        setQueryId: (state, {payload}: {payload: string}) => {
            state.queryId = payload;
        },
        selectAudienceRowAction: (state, {payload}: { payload: { query_id: string; selected: boolean } }) => {
            state.audiencesList = state.audiencesList.map((row) => {
                if (row.query_id === payload.query_id) {
                    return {...row, selected: payload.selected};
                }
                return row;
            });
        },
        selectAllAudienceRowsAction: (state, {payload}: { payload: boolean }) => {
            state.audiencesList = state.audiencesList.map((row) => {
                return {...row, selected: payload};
            });
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAudiencesList.pending, (state) => {
                state.audiencesList = [];
            })
            .addCase(fetchAudiencesList.fulfilled, (state, {payload}) => {
                state.audiencesList = payload;
            })
            .addCase(fetchFiltration.fulfilled, (state, {payload}) => {
                state.generalAudiencesSizeData.existing_wallets = payload.number_of_existing_wallets;
                state.generalAudiencesSizeData.identified_wallets = payload.number_of_identified_wallets;
                state.generalAudiencesSizeData.avg_wallet_wealth = payload.avg_wealth;
                // state.queryId = payload.query_id;
            })
    },
});

export const {
    selectAudienceRowAction,
    selectAllAudienceRowsAction,
    setQueryId,
} = audienceSlice.actions;

export default audienceSlice.reducer;
